import styled from "styled-components";
import FiltersButton from "../FiltersButton";
import Filters from "../Filters";

export const AppFilters = styled(Filters)`
  position: absolute;
  z-index: 3;
  height: 100%;
  width: 100%;

  @media (min-width: 640px) {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 310px;
  }
`;

export const MapFiltersButton = styled(FiltersButton)`
  display: none;

  @media (min-width: 640px) {
    display: flex;
    position: absolute;
    top: 70px;
    right: 20px;
    z-index: 2;
  }
`;

export const StateMarker = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  width: 40px;
  height: 40px;
  border-radius: 25px;
  color: #2B345F;
  text-align: center;
  font-family: var(--font-primary);
  transition: all 0.25s ease;

  &:hover {
    transform: scale(1.25);
  }

  background: ${(props) => props.color};
`;
